// This is just an example,
// so you can safely delete all default props below

export default {
    signin_title: 'Login',
    signin_desc: 'Login to the boat booking solution.<br/>- Login to MyPage at kolumbus.no can not be used here.<br/>- A user account/login to the boat booking solution is optional to have/use to buy/reserve boat tickets.',
    signin: 'Login',
    signup: 'Create user',
    email: 'Email',
    password: 'Password',
    stay_signed_in: 'Stay signed in?',
    forget_password: 'Forgot password?',
    error_email: 'Email is not valid',
    error_password: 'Password must be provided',
    error_sign_in: 'The email and password combination is not correct'
}